<template>
  <div
    target="_blank"
    text
    class="white--text row-flex align-center"
    :ripple="false"
  >
    <div
      class="gradient-btn mr-6 pointer"
      :class="toCompare === 2 && 'bg-green'"
      v-ripple
      @click="$router.push('/comparison')"
    >
      <div class="btn-badge">
        {{toCompare}}
      </div>
    </div>
    <div class="flex-center-content menu-btn" :class="showMenu && 'open'">
      <div class="img-container flex-center-content">
        <img
          @click.stop="onMenuClick"
          class="pointer"
          style="width: 34px; height: auto"
          :src="require(`@/assets/img/${showMenu ? 'close.png' : 'hamburger.png'}`)" 
        />
      </div>
    </div>
    
  </div>  
</template>

<script>
import eventBus from '@/eventBus.js'

export default {
  name: 'nav-actions',
  computed: {
    toCompare: function() {
      if(this.$store.state.toCompare.length === 0)
        return '';
      return this.$store.state.toCompare.length;
    }
  },
  data: () => ({
    showMenu: false
  }),
  mounted() {
    eventBus.$on('closeMenu', () => {
      this.showMenu = false;
    })
  },
  methods: {
    onMenuClick() {
      this.showMenu = !this.showMenu;
      eventBus.$emit('toggleMenu', this.showMenu);
    }
  }
}
</script>

<style lang="scss" scoped>
.gradient-btn {
  position: relative;
  width: 50px;
  height: 50px;
  background: linear-gradient(45deg, #021325 0%, #2F5678 100%);
  box-shadow: 0px 2px 7px rgba(80, 80, 80, 0.118854);
  border-radius: 14px;
  overflow: visible;
  transform: scale(0.9);

  &::after {
    content: '';
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    
    background-image: url('~@/assets/img/compare.png');
    background-position: center;
    background-repeat: no-repeat;
  }

  .btn-badge {
    position: absolute;
    font-size: 18px;
    right: 4px;
    top: 4px;
  }
}
.menu-btn {
  border-radius: 10px;
  transition: all 0.25s;

  .img-container {
    width: 34px;
    height: 20.7px;
  }
  &.open {
    transform: rotateZ(180deg);

    img {
      height: 19px !important;
      width: auto !important;
    }
  }
}
</style>